// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Paper from '@mui/material/Paper'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import Typography from '@mui/material/Typography'
import forEach from 'lodash/forEach'
import get from 'lodash/get'
import React from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import { i18n } from '../../index'
import type { Station } from '../../station/stationTypes'
import withActiveStation from '../../station/withActiveStation'
import { vitrineProductTimeslotWeightsQuery, vitrineProductWeightsQuery } from './vitrineProductQueries'
import VitrineProductTimeSlotWeightsTable from './VitrineProductTimeSlotWeightsTable'
import type { VitrineProductWithWeight } from './vitrineProductTypes'
import css from './vitrineProductWeights.css'
import VitrineProductWeightsTable from './VitrineProductWeightsTable'
type Props = {
  activeStation: Station
}
type State = {
  productTypeTab: string
  timeSlotTab: string
  weekday: string
}
const saltyTimeSlots = ['06', '14', '21']
const sweetTimeSlots = ['06', '10', '15', '21', '01']

const getTimeSlotData = (data: any, timeSlot: string): Array<VitrineProductWithWeight> => {
  let returnValue = []
  forEach(data, (item) => {
    if (item.timeslot === timeSlot) {
      returnValue = get(item, 'weights', [])
      return false
    }
  })
  return returnValue
}

@withActiveStation
class VitrineProductWeights extends React.PureComponent<Props, State> {
  state = {
    productTypeTab: 'Salty',
    timeSlotTab: '06',
    weekday: 'Weekday',
  }
  onWeekdayChange = (weekday: string) => {
    this.setState({
      weekday,
    })
  }

  render() {
    const { activeStation } = this.props
    const { productTypeTab, timeSlotTab, weekday } = this.state
    const stationId = activeStation.id
    return (
      <div className={css.component}>
        <Query
          query={vitrineProductTimeslotWeightsQuery}
          variables={{
            stationId,
            weekday,
          }}
          fetchPolicy='network-only'
        >
          {({ loading, error, data }) => {
            const saltyTimeSlotWeightsData = get(data, 'saltyVitrineProductTimeSlotWeights', [])
            const sweetTimeSlotWeightsData = get(data, 'sweetVitrineProductTimeSlotWeights', [])
            return (
              <Loader
                {...{
                  loading,
                  error,
                }}
              >
                <div className={css.top}>
                  <Typography variant='h6'>{i18n.t('admin.vitrineProducts.weights.pageTitle')}</Typography>
                </div>
                <Typography variant='subtitle1' className={css.subtitle}>
                  {i18n.t('admin.vitrineProducts.weights.timeSlotWeightsTitle')}
                </Typography>
                <Paper className={css.timeSlotWeightsTable}>
                  <VitrineProductTimeSlotWeightsTable
                    stationId={stationId}
                    weekday={weekday}
                    onWeekdayChange={this.onWeekdayChange}
                    data={{
                      Salty: saltyTimeSlotWeightsData,
                      Sweet: sweetTimeSlotWeightsData,
                    }}
                  />
                </Paper>
              </Loader>
            )
          }}
        </Query>
        <Query
          query={vitrineProductWeightsQuery}
          variables={{
            stationId,
          }}
          fetchPolicy='network-only'
        >
          {({ loading, error, data }) => {
            const productWeightDataKey =
              productTypeTab === 'Salty' ? 'saltyVitrineProductWeights' : 'sweetVitrineProductWeights'
            const timeSlotData = getTimeSlotData(get(data, productWeightDataKey, []), timeSlotTab)
            return (
              <Loader
                {...{
                  loading,
                  error,
                }}
              >
                <Typography variant='subtitle1' className={css.subtitle}>
                  {i18n.t('admin.vitrineProducts.weights.productWeightsTitle')}
                </Typography>
                <Paper>
                  <Tabs
                    indicatorColor='primary'
                    textColor='primary'
                    value={productTypeTab}
                    onChange={(e, value) =>
                      this.setState({
                        productTypeTab: value,
                        timeSlotTab: '06',
                      })
                    }
                  >
                    <Tab
                      className={css.productTypeTab}
                      disableRipple
                      value='Salty'
                      label={i18n.t('admin.vitrineProducts.products.title.saltyProducts')}
                    />
                    <Tab
                      className={css.productTypeTab}
                      disableRipple
                      value='Sweet'
                      label={i18n.t('admin.vitrineProducts.products.title.sweetProducts')}
                    />
                  </Tabs>
                  <Tabs
                    className={css.timeSlotTabs}
                    indicatorColor='primary'
                    textColor='primary'
                    value={timeSlotTab}
                    onChange={(e, value) =>
                      this.setState({
                        timeSlotTab: value,
                      })
                    }
                  >
                    {(productTypeTab === 'Salty' ? saltyTimeSlots : sweetTimeSlots).map((timeSlot, i) => (
                      <Tab key={i} disableRipple value={timeSlot} label={timeSlot} />
                    ))}
                  </Tabs>
                  <VitrineProductWeightsTable
                    stationId={stationId}
                    timeSlot={timeSlotTab}
                    data={timeSlotData}
                    weekday={weekday}
                  />
                </Paper>
              </Loader>
            )
          }}
        </Query>
      </div>
    )
  }
}

export default VitrineProductWeights
